import { useCallback, type ReactElement } from 'react';
import { Link } from 'react-router';
import { useListePaginee } from '../coquille/useChargement.js';
import { CHEMINS } from '../routes.js';

/**
 * L ADMINISTRATION ANELYA [contrat 28-BU] — L INVENTAIRE [29-I].
 *
 * MONDE PLATEFORME, distinct du monde locataire. Un operateur n est pas
 * membre des clients qu il cree : ceux-ci n apparaissent donc PAS dans
 * MesEspaces, et c est voulu -- les y faire figurer serait une donnee de
 * complaisance et melerait deux modeles d autorisation.
 *
 * ╔═══════════════════════════════════════════════════════════════════════╗
 * ║ LECTURE SEULE. AUCUN GESTE SUR CET ECRAN.                             ║
 * ╚═══════════════════════════════════════════════════════════════════════╝
 *
 * Les cartes OUVRENT un client, rien de plus. Des boutons de suspension sur
 * chaque carte d un inventaire invitent au clic de travers : les gestes de
 * portee CLIENT vivent dans l ecran du client, ou l on sait lequel on regarde.
 *
 * AUCUN FILTRE D ETAT : un client suspendu doit se voir, sinon on ne pourrait
 * plus le reactiver. Les compteurs sont un INVENTAIRE TOTAL, archives compris
 * -- un compteur qui pretendrait dire « ce qui tourne » devrait peser
 * l armement, le deploiement et l etat du projet.
 *
 * AUCUNE MENTION DE PROPRIETAIRE, tant que la dette 50 n est pas arbitree :
 * rien ne garantit qu un locataire n en ait qu UN, et quatre des six clients
 * de production n en ont AUCUN.
 *
 * L AFFICHAGE N EST PAS UNE AUTORISATION : meme atteint par l URL, chaque
 * route exige `exploitation`.
 */
interface LigneClient {
  readonly id: string;
  readonly code: string;
  readonly nom: string;
  readonly etat: string;
  readonly archive: boolean;
  readonly nombreProjets: number;
  readonly nombreAutomatisations: number;
  readonly nombreMembres: number;
}
interface ReponseClients {
  readonly clients: readonly LigneClient[];
  readonly curseurSuivant: string | null;
}

export function Plateforme(): ReactElement {
  const extraire = useCallback((r: ReponseClients) => ({
    lignes: r.clients, curseur: r.curseurSuivant,
  }), []);
  const { etat, chargerSuite } = useListePaginee<ReponseClients, LigneClient>(
    '/plateforme/clients', extraire);

  return (
    <div className="contenu">
      {/* ENVELOPPE PROVISOIRE [29-I]. Le monde plateforme n a PAS de coquille
          locataire, donc aucun conteneur ne lui donnait de marge : au smoke du
          07/09 les cartes touchaient le bord et la derniere sortait de l ecran.
          `.contenu` est reprise pour son `padding` -- son `grid-area` est inerte
          hors `.coquille`. Ce n est PAS l enveloppe definitive du monde
          plateforme : l harmonisation de l affichage est 29-M. */}
    <section>
      {/* SORTIE EXPLICITE : le monde plateforme n a pas la coquille
          locataire, donc pas de marque cliquable. Sans ce lien, on entre
          ici sans pouvoir en sortir. */}
      <p><Link to={CHEMINS.espaces}>&larr; Mes espaces</Link></p>
      <h1>Administration Anelya</h1>
      <h2>Clients</h2>
      <p>
        <Link className="bouton bouton--discret" to={CHEMINS.nouveauClient}>
          + Nouveau client</Link>
      </p>

      {etat.phase === 'chargement' && <p className="etat-vide">Chargement…</p>}
      {etat.phase === 'echec' && (
        <p className="etat-vide">L inventaire n a pas pu être chargé.</p>
      )}
      {etat.phase === 'pret' && etat.donnees.lignes.length === 0 && (
        <p className="etat-vide">Aucun client pour le moment.</p>
      )}
      {etat.phase === 'pret' && etat.donnees.lignes.length > 0 && (
        <>
          {/* `.grille` MET LES CARTES EN COLONNE et les espace : c est elle
              qui porte `display:flex` dans structure.css. `liste-cartes`, elle,
              n est definie NULLE PART [dette 56] -- au smoke du 07/09 les cartes
              se chevauchaient et les <span> se collaient en ligne. Les balises
              sont donc des BLOCS, comme dans Environnements.tsx. */}
          <div className="grille">
            {etat.donnees.lignes.map((c) => (
              <Link className="carte" key={c.id} to={CHEMINS.clientPlateforme(c.id)}>
                <h2 className="carte__titre">{c.nom}</h2>
                <p className="carte__detail">
                  {c.code} — {c.archive ? 'archive'
                    : c.etat === 'suspendu' ? 'suspendu' : 'actif'}
                </p>
                <p className="discret">
                  {c.nombreProjets} projet(s) · {c.nombreAutomatisations} automatisation(s)
                  {' · '}{c.nombreMembres} membre(s)
                </p>
              </Link>
            ))}
          </div>
          {etat.donnees.curseurSuivant !== null && (
            <p>
              <button type="button" disabled={etat.donnees.chargeSuite}
                onClick={() => { chargerSuite(); }}>
                {etat.donnees.chargeSuite ? 'Chargement…' : 'Charger la suite'}
              </button>
            </p>
          )}
        </>
      )}
    </section>
    </div>
  );
}
